/**
 * Pillar 5 — Impact Chip.
 *
 * Single severity pill. Used in the War Room header (project pulse) and the
 * Operations Dashboard Morning Roll Call banner.
 */
import React from "react";

const STYLES = {
  critical: {
    label: "Critical",
    fg: "#fecaca",
    bg: "rgba(220, 38, 38, 0.18)",
    border: "rgba(220, 38, 38, 0.6)",
  },
  high: {
    label: "High",
    fg: "#fde68a",
    bg: "rgba(245, 158, 11, 0.18)",
    border: "rgba(245, 158, 11, 0.6)",
  },
  moderate: {
    label: "Moderate",
    fg: "#fed7aa",
    bg: "rgba(249, 115, 22, 0.18)",
    border: "rgba(249, 115, 22, 0.6)",
  },
  low: {
    label: "Low",
    fg: "#bae6fd",
    bg: "rgba(56, 189, 248, 0.16)",
    border: "rgba(56, 189, 248, 0.55)",
  },
  no: {
    label: "No Impact",
    fg: "var(--fop-text-3)",
    bg: "transparent",
    border: "var(--fop-border)",
  },
};

export default function ImpactChip({ severity = "no", count, testid, size = "sm" }) {
  const cfg = STYLES[severity] || STYLES.no;
  if (count === 0 && severity !== "no") {
    return (
      <span
        className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-mono uppercase tracking-wider opacity-60`}
        style={{ color: "var(--fop-text-3)", borderColor: "var(--fop-border)", border: "1px solid" }}
        data-testid={testid}
      >
        {cfg.label} · 0
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-mono uppercase tracking-wider`}
      style={{
        color: cfg.fg,
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
      }}
      data-testid={testid}
      data-severity={severity}
    >
      {cfg.label}
      {typeof count === "number" && <span style={{ marginLeft: 4 }}>· {count}</span>}
    </span>
  );
}
